import React from 'react'
import {
  withStyles,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@material-ui/core'
import { Icon } from '@iconify/react'
import { useHistory } from 'react-router-dom'
import styles from './styles'

const SettingsNavigation = props => {
  const { classes, items, activeItem, collectionId } = props
  const history = useHistory()

  const handleChange = event => {
    const path = event.target.value
    history.push(`/collection/${collectionId}/settings/${path}`)
  }

  return (
    <>
      {/* Mobile View */}
      <FormControl variant="outlined" className={classes.mobileSelect}>
        <InputLabel>Settings</InputLabel>
        <Select
          value={activeItem || ''}
          onChange={handleChange}
          label="Settings"
          className={classes.select}
        >
          {items.map(item => (
            <MenuItem key={item.path} value={item.path}>
              <div className={classes.menuItem}>
                <Icon icon={item.icon} />
                <Typography fontWeight={400}>{item.label}</Typography>
              </div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Desktop View */}
      <div className={classes.leftSideList}>
        {items.map(item => {
          return (
            <div
              key={item.path}
              className={`${classes.leftSideListItem} ${
                activeItem === item.path ? classes.active : ''
              }`}
              onClick={() => {
                history.push(
                  `/collection/${collectionId}/settings/${item.path}`,
                )
              }}
            >
              <Icon
                icon={item.icon}
                style={{
                  width: '18px',
                  height: '18px',
                }}
              />
              <Typography fontWeight={400}>{item.label}</Typography>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default withStyles(styles)(SettingsNavigation)
